import {Grid, Typography} from '@material-ui/core';
import {makeStyles, useTheme} from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    table: {
        border: `1px solid ${theme.palette.gray.light}`,
    },
}));

const TimeLeft = () => {
    const theme = useTheme();
    const classes = useStyles();
    return (
        <Grid
            container
            className={classes.table}
            style={{textAlign: 'center', padding: '1em'}}
        >
            <Grid item xs={12} style={{margin: '1em'}}>
                <Typography variant='h6'>Time Left</Typography>
            </Grid>
            <Grid
                item
                xs={4}
                style={{
                    border: `1px solid ${theme.palette.gray.light2}`,
                    backgroundColor: theme.palette.charts.green,
                }}
            >
                <Typography variant='overline'>1 Year</Typography>
            </Grid>
            <Grid
                item
                xs={4}
                style={{
                    border: `1px solid ${theme.palette.gray.light2}`,
                    backgroundColor: theme.palette.charts.lightOrange,
                }}
            >
                <Typography variant='overline'>180 Days</Typography>
            </Grid>
            <Grid
                item
                xs={4}
                style={{
                    border: `1px solid ${theme.palette.gray.light2}`,
                    backgroundColor: theme.palette.charts.lightRed,
                }}
            >
                <Typography variant='overline'>30 Days</Typography>
            </Grid>
        </Grid>
    );
};

export default TimeLeft;
